class SwinglyChatData {
    constructor() {
        this.cachedGroups = null;
        this.cachedUsers = null;
        this.cachedCurrentUserGroups = null;
        this.nonce = window.wpApiSettings ? window.wpApiSettings.nonce : '';
    }

    getHeaders() {
        return {
            'X-WP-Nonce': this.nonce,
            'Content-Type': 'application/json'
        };
    }

    async fetchCurrentUser() {
        const response = await fetch('/wp-json/swingly/v1/current-user', {
            headers: this.getHeaders()
        });
        if (!response.ok) {
            throw new Error('Failed to fetch current user');
        }

        return await response.json();
    }
    
    async fetchUsers(userId = null) {
        // Return cached data if available
        if (this.cachedUsers !== null) {
            return this.cachedUsers;
        }

        let url = '/wp-json/swingly/v1/users';
        if (userId) {
            url += `?exclude_user=${userId}`;
        }
        
        const response = await fetch(url, {
            headers: this.getHeaders()
        });

        if (!response.ok) {
            throw new Error('Failed to fetch users');
        }

        this.cachedUsers = await response.json();
        return this.cachedUsers;
    }

    async fetchGroups() {
        // Return cached data if available
        if (this.cachedGroups !== null) {
            return this.cachedGroups;
        }

        const response = await fetch('/wp-json/swingly/v1/groups', {
            headers: this.getHeaders()
        });
        if (!response.ok) {
            throw new Error('Failed to fetch groups');
        }
        
        // Cache the result
        this.cachedGroups = await response.json();
        return this.cachedGroups;
    }

    async fetchCurrentUserGroups() {
        // Return cached data if available
        if (this.cachedCurrentUserGroups !== null) {
            return this.cachedCurrentUserGroups;
        }

        const response = await fetch('/wp-json/swingly/v1/current-user-groups', {
            headers: this.getHeaders()
        });
        if (!response.ok) {
            throw new Error('Failed to fetch current user groups');
        }
        
        // Cache the result
        this.cachedCurrentUserGroups = await response.json();
        return this.cachedCurrentUserGroups;
    }
}

export default SwinglyChatData; 